import { FC, useEffect } from 'react';
import { Box } from '@mui/material';
import backgroundImage from '../../assets/images/pvx-home-bg.png';
import useAuth from '../../hooks/useAuth';
import { useTranslation } from 'react-i18next';

const AuthRedirect: FC = () => {
  const { loginUrl } = useAuth();
  const { t: translations } = useTranslation();

  // Hook to redirect to keycloak login page
  useEffect(() => {
    window.location.href = loginUrl;
  }, []);

  return (
    <>
      <Box
        sx={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#FFFFFF',
          textAlign: 'center',
        }}
      >
        <div>
          <p>{translations('common.authenticating')}</p>
        </div>
      </Box>
    </>
  );
};

export default AuthRedirect;
